import {
	PROMO_CODE_STATUS_START,
	PROMO_CODE_STATUS_SUCCESS,
	PROMO_CODE_STATUS_ERROR,
	PROMO_CODE_ADD_START,
	PROMO_CODE_ADD_SUCCESS,
	PROMO_CODE_ADD_ERROR,
	DELETE_PROMO_CODE_START,
	DELETE_PROMO_CODE_SUCCESS,
	DELETE_PROMO_CODE_ERROR,
	VALIDATE_PROMO_CODE_START,
	VALIDATE_PROMO_CODE_SUCCESS,
	VALIDATE_PROMO_CODE_ERROR

} from '../../../constants';
import moment from 'moment';
import { change } from 'redux-form';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { updatePromoStatus, updatePromoCode, deletePromoCode, validatePromoCode } from '../../../lib/graphql';
import history from '../../../core/history';


export function updatePromoCodeData(values) {
	return async (dispatch, getState, { client }) => {

		await dispatch({ type: PROMO_CODE_ADD_START });
		const dynamicPromoCode = values?.dynamicPromoCode?.length > 0 ? JSON.stringify(values.dynamicPromoCode) : JSON.stringify([]);

		try {
			const { data } = await client.mutate({
				mutation: updatePromoCode,
				variables: {
					id: Number(values?.id),
					title: values?.dynamicPromoCode?.[0]?.title,
					description: values?.dynamicPromoCode?.[0]?.description,
					code: values?.code,
					promoValue: Number(values?.promoValue),
					expiryDate: values?.expiryDate ? moment(Number(values?.expiryDate)).format('YYYY-MM-DD') : null,
					isEnable: values?.isEnable == 'true' ? true : false,
					deductionType: values?.deductionType,
					dynamicPromoCode: dynamicPromoCode
				}
			});

			if (data?.updatePromoCode?.status === 200) {
				await dispatch({
					type: PROMO_CODE_ADD_SUCCESS,
				});
				history.push('/siteadmin/promo-code');
				showToaster({ messageId: values?.id ? 'promoCodeUpdated' : 'promoCodeAddedSuccess', toasterType: 'success' })
			} else {
				showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.updatePromoCode?.errorMessage })
				await dispatch({
					type: PROMO_CODE_ADD_ERROR,
					payload: {
						error: data?.updatePromoCode?.errorMessage
					}
				});
			}
		} catch (error) {
			await dispatch({
				type: PROMO_CODE_ADD_ERROR,
				payload: {
					error
				}
			});
		}
	}
}

export function updatePromoCodeStatus(id, isEnable) {
	return async (dispatch, getState, { client }) => {
		dispatch({ type: PROMO_CODE_STATUS_START });
		try {
			const { data } = await client.mutate({
				mutation: updatePromoStatus,
				variables: { id, isEnable },
			});

			if (data && data.updatePromoStatus && data.updatePromoStatus.status == 200) {
				dispatch({
					type: PROMO_CODE_STATUS_SUCCESS
				});
				showToaster({ messageId: 'promoCodeUpdatedSuccess', toasterType: 'success' })
				return true;
			} else {
				dispatch({
					type: PROMO_CODE_STATUS_ERROR
				});
				showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.updatePromoStatus?.errorMessage })
			}

		} catch (error) {
			dispatch({
				type: PROMO_CODE_STATUS_ERROR
			});
			showToaster({ messageId: 'updateFailed', toasterType: 'error' })
		}
	}
}



export function deletePromoCodeData(id) {
	return async (dispatch, getState, { client }) => {
		dispatch({ type: DELETE_PROMO_CODE_START });
		try {
			const { data } = await client.mutate({
				mutation: deletePromoCode,
				variables: { id },
			});
			if (data && data.deletePromoCode && data.deletePromoCode.status == 200) {
				dispatch({
					type: DELETE_PROMO_CODE_SUCCESS
				});
				showToaster({ messageId: 'promoDeletedSuccess', toasterType: 'success' });
				return true;
			} else {
				dispatch({
					type: DELETE_PROMO_CODE_ERROR
				});
				showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.deletePromoCode?.errorMessage })
			}

		} catch (error) {
			dispatch({
				type: DELETE_PROMO_CODE_ERROR
			});
			showToaster({ messageId: 'updateFailed', toasterType: 'error' })
		}
	}
}

export function validatePromoCodeData(code) {
	return async (dispatch, getState, { client }) => {
		dispatch({
			type: VALIDATE_PROMO_CODE_START,
			payload: {
				validPromoCode: false,
				promoCodeLoading: true
			}
		});
		try {
			const { data } = await client.query({
				query: validatePromoCode,
				variables: { code },
				fetchPolicy: 'network-only',
			});

			if (data?.validatePromoCode?.status == 200) {
				dispatch({
					type: VALIDATE_PROMO_CODE_SUCCESS,
					payload: {
						validPromoCode: true,
						promoCodeLoading: false
					}
				});

				await dispatch(change('BookingForm', 'promoId', data?.validatePromoCode?.result?.id));
				await dispatch(change('BookingForm', 'promoValue', data?.validatePromoCode?.result?.promoValue));
				await dispatch(change('BookingForm', 'promoCode', data?.validatePromoCode?.result?.code));
				await dispatch(change('BookingForm', 'deductionType', data?.validatePromoCode?.result?.deductionType));
				await dispatch(change('BookingForm', 'description', data?.validatePromoCode?.result?.description));
				await dispatch(change('PaymentForm', 'editPayment', false));
				await dispatch(change('BookingForm', 'dynamicPromoCode', data?.validatePromoCode?.result?.dynamicPromoCode));

				return true;
			} else {
				dispatch({
					type: VALIDATE_PROMO_CODE_ERROR,
					payload: {
						validPromoCode: false,
						promoCodeLoading: false
					}
				});
				await dispatch(change('BookingForm', 'promoId', null));
				await dispatch(change('BookingForm', 'promoCode', null));
				await dispatch(change('BookingForm', 'promoValue', 0));
				await dispatch(change('BookingForm', 'deductionType', null));
				await dispatch(change('BookingForm', 'description', null));

				showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.validatePromoCode?.errorMessage })
			}
		} catch (error) {
			dispatch({
				type: VALIDATE_PROMO_CODE_ERROR,
				payload: {
					validPromoCode: false,
					promoCodeLoading: false
				}
			});
			await dispatch(change('BookingForm', 'promoId', null));
			await dispatch(change('BookingForm', 'promoCode', null));
			await dispatch(change('BookingForm', 'promoValue', 0));
			await dispatch(change('BookingForm', 'deductionType', null));

			showToaster({ messageId: 'updateFailed', toasterType: 'error' })
		}
	}
}